import React, { ReactNode } from "react";
import MediaQuery from "react-responsive";

export function MobileOnly(props: ResponsiveComponentProps) {
    return (
        <MediaQuery maxWidth={767}>
            {props.children}
        </MediaQuery>
    );
}

export function MobileHidden(props: ResponsiveComponentProps) {
    return (
        <MediaQuery minWidth={768}>
            {props.children}
        </MediaQuery>
    );
}

export interface ResponsiveComponentProps {
    children?: ReactNode,
}
